import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { NoteIcon } from './icons';
import { tokens } from '../../../design';
import type { MoneyHealthText } from '../_lib/moneyHealthText';

/**
 * One footnote line under a section: an icon plus a sentence the server's
 * numbers decided.
 *
 * This is where «Показаны 25 из ≥ 118 — список обрезан сервером.» lives. It is
 * NOT a pager: `AdminDataGrid`'s footer is hardcoded to `paginationMode
 * ="server"` and would render «1–25 из 900» with a live next-page arrow
 * calling a cursor this endpoint does not have — and with `countExact: false`
 * it would derive a page count from a number the server calls a floor. A list
 * that states its own truncation is the honest shape here.
 */
export const SectionMeta = ({
  text,
  icon,
  testId,
}: {
  text: MoneyHealthText;
  icon?: ReactNode;
  testId?: string;
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <Box
      data-testid={testId ?? 'section-meta'}
      sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}
    >
      <Box
        aria-hidden
        sx={{ flexShrink: 0, mt: '1px', color: 'inherit', '& svg': { width: 13, height: 13 } }}
      >
        {icon ?? <NoteIcon />}
      </Box>
      <Typography sx={{ fontSize: 11, lineHeight: '15px', color: tokens.text.tertiary }}>
        {t(text.key, { ...text.values })}
      </Typography>
    </Box>
  );
};
